import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import styled from "styled-components";
import NewCustomRadio from "../radioButtons/NewCustomRadio";
import { useTranslation } from "react-i18next";
import FloatingInput from "../inputFields/FloatingInput";
import { Box, SpanStyled } from "../../styled/Elements";
import { PlaceholderImg, SearchIcon } from "../../styled/AllImages";

export function UsersDropdown({
  optionsList,
  selecteduser,
  placeholder,
  onChange,
  name,
  viewAll,
}) {
  const { t } = useTranslation();
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const [filteredOptions, setFilteredOptions] = useState(optionsList);
  const handleSearch = (e) => {
    const { value } = e.target;
    const searchQuery = value.toLowerCase();

    const updatedList = optionsList.filter((item) => {
      if (item?.name) {
        return item?.name.toLowerCase().includes(searchQuery);
      }
      return item?.subLabel?.toLowerCase().includes(searchQuery);
    });

    setFilteredOptions(updatedList);
  };

  useEffect(() => {
    if (optionsList) setFilteredOptions(optionsList);
  }, [optionsList]);

  return (
    <StyledDropdown>
      <Dropdown>
        <Dropdown.Toggle variant="light" id="dropdown-basic">
          {selecteduser ? (
            selecteduser.name
          ) : (
            <SpanStyled color="var(--text2)">{placeholder}</SpanStyled>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu className="custom-scroll">
          <Box className="mb-1 mt-3 mx-4">
            <FloatingInput
              name="search"
              type="input"
              fieldType="text"
              label={t("search")}
              placeholder={t("search")}
              icon={SearchIcon}
              onChange={handleSearch}
            />
          </Box>

          {viewAll ? (
            <div className="user-option">
              <NewCustomRadio
                name={name}
                label={t("all")}
                subLabel={t("view_all")}
                className={"px-4"}
                value={""}
                onChange={onChange}
              />
            </div>
          ) : null}
          {filteredOptions?.map((user, index) => (
            <div key={index} className="user-option">
              <NewCustomRadio
                name={name}
                avatar={
                  user.profile ? `${ASSET_URL}/${user.profile}` : PlaceholderImg
                }
                label={t(user?.name)}
                subLabel={t(user?.position ? user.position : user.subLabel)}
                className={"px-4"}
                value={user?.name}
                onChange={onChange}
              />
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </StyledDropdown>
  );
}
export function DropdownWithSearch({
  name,
  onChange,
  optionsList,
  selectedoption,
  placeholder,
}) {
  const { t } = useTranslation();
  const [filteredOptions, setFilteredOptions] = useState(optionsList);
  const handleSearch = (e) => {
    const { value } = e.target;
    const searchQuery = value.toLowerCase();

    const updatedList = optionsList.filter((item) => {
      if (item?.name) {
        return item?.name.toLowerCase().includes(searchQuery);
      }
      return item?.subLabel?.toLowerCase().includes(searchQuery);
    });

    setFilteredOptions(updatedList);
  };

  useEffect(() => {
    if (optionsList) setFilteredOptions(optionsList);
  }, [optionsList]);

  return (
    <StyledDropdown>
      <Dropdown>
        <Dropdown.Toggle variant="light" id="dropdown-basic">
          {selectedoption ? (
            <SpanStyled color="var(--text2)">
              {filteredOptions?.find((item) => item?.id == selectedoption)?.name}
            </SpanStyled>
          ) : (
            <SpanStyled color="var(--text2)">{placeholder}</SpanStyled>
          )}
        </Dropdown.Toggle>

        <Dropdown.Menu className="custom-scroll">
          <Box className="mb-1 mt-3 mx-4">
            <FloatingInput
              name="search"
              type="input"
              fieldType="text"
              label={t("search")}
              placeholder={t("search")}
              icon={SearchIcon}
              onChange={handleSearch}
            />
          </Box>

          <div className="user-option">
            <NewCustomRadio
              name={name}
              value={""}
              label={t("all")}
              className={"px-4"}
              onChange={onChange}
            />
          </div>
          {filteredOptions?.map((item, index) => (
            <div key={index} className="user-option">
              <NewCustomRadio
                name={name}
                value={item?.id}
                label={item?.name}
                subLabel={item?.subLabel}
                className={"px-4"}
                onChange={onChange}
              />
            </div>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </StyledDropdown>
  );
}

const StyledDropdown = styled.div`
  min-width: 180px;
  .dropdown-toggle {
    position: relative;
    width: 100%;
    height: 48px;
    text-align: start;
    border-radius: 10px;
    border: 1px solid var(--borderLight);
    padding: 10px;
    background-color: var(--white);
    font-size: 14px;
    color: var(--text);
  }
  .dropdown-toggle::after {
    position: absolute;
    right: 10px;
    top: 20px;
    body.rtl & {
      right: unset;
      left: 10px;
    }
  }

  .dropdown-menu {
    max-height: 350px;
    overflow-y: auto;
    width: 400px;
    min-width: 250px;
    border-radius: 10px;
    border: 1px solid var(--borderLight);
  }

  .user-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    cursor: pointer;
    border-bottom: 1px solid var(--borderLight);

    &:last-child {
      border: none;
    }

    .user-name {
      font-size: 16px;
      font-weight: 500;
    }

    .branch-name {
      font-size: 12px;
      color: gray;
    }

    .status {
      color: green;
      font-size: 18px;
    }
  }
`;
